import { type IconProps, HowItWorksIcon } from './HowItWorksIcon'

export const HIW3 = (props: IconProps) => (
  <HowItWorksIcon name='hiw3' {...props} />
)
